"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
require("./Styles/Locations.css");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Types_1 = require("./Types");
var Util_1 = require("../../../../Services/Util");
var Endpoints_1 = require("../../../../Utils/Endpoints");
var AuthenticationService_1 = require("../../../../Services/AuthenticationService");
var react_bootstrap_table_next_1 = require("react-bootstrap-table-next");
var react_bootstrap_table2_paginator_1 = require("react-bootstrap-table2-paginator");
var Exports_1 = require("../../Components/Exports");
var getColumns = function (apiProvider, resources) {
    if (apiProvider === "Ssr") {
        return [{
                dataField: 'Name',
                text: resources.LocationName,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Actions',
                text: '',
                sort: false,
                style: {
                    verticalAlign: 'middle'
                },
                headerStyle: {
                    width: '20%'
                }
            }];
    }
    else {
        return [{
                dataField: 'Name',
                text: resources.LocationName,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Type',
                text: resources.LocationType,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Expiry',
                text: resources.Expires,
                sort: true,
                style: {
                    verticalAlign: 'middle'
                }
            }, {
                dataField: 'Actions',
                text: '',
                sort: false,
                style: {
                    verticalAlign: 'middle'
                },
                headerStyle: {
                    width: '20%'
                }
            }];
    }
};
var defaultSorted = [{
        dataField: 'Name',
        order: 'asc'
    }];
var Locations = /** @class */ (function (_super) {
    __extends(Locations, _super);
    function Locations(props) {
        var _this = _super.call(this, props) || this;
        _this.addActionsToLocationData = function (locationData) {
            locationData.map(function (location) {
                var expiryCheck = false;
                if (_this.props.applicationData.apiProvider !== "Ssr" && location.Expiry !== undefined && location.Expiry.length == 10) {
                    var expiryDate = new Date(location.Expiry);
                    var renewalThreshold = new Date();
                    renewalThreshold.setDate(renewalThreshold.getDate() + 60);
                    expiryCheck = expiryDate < renewalThreshold;
                }
                location.Actions = (React.createElement("div", { style: {
                        display: 'flex', justifyContent: 'space-evenly', lineHeight: '2.5', color: "transparent", minHeight: "2.4rem"
                    } },
                    _this.props.applicationData.apiProvider !== "Ssr" && expiryCheck &&
                        React.createElement(Exports_1.ActionButton, { Event: Types_1.ArvatoRenewCertEvent(location.Name, _this.certRenewalUpdateCallback, _this.props.applicationData), TooltipText: _this.props.applicationData.resources.RenewCertificate, Icons: free_solid_svg_icons_1.faFileContract, colour: "primary" }),
                    _this.props.applicationData.apiProvider !== "Ssr" &&
                        React.createElement(Exports_1.ActionButton, { Event: Types_1.ArvatoChangePasswordEvent(location.Name, _this.props.applicationData), TooltipText: _this.props.applicationData.resources.ChangePassword, MultipleIcons: true, Icons: [free_solid_svg_icons_1.faLock, free_solid_svg_icons_1.faSyncAlt], colour: "primary" }),
                    _this.props.applicationData.selectedLocation != location.Name &&
                        React.createElement(Exports_1.ActionButton, { Event: Types_1.DeleteLocationEvent(location.Name, _this.updateCallback, _this.props.applicationData.resources), TooltipText: _this.props.applicationData.resources.Delete, Icons: free_solid_svg_icons_1.faTrash, colour: "danger" })));
            });
            return locationData;
        };
        _this.getLocationExpiry = function (location) {
            return Util_1.getJson(Endpoints_1.default.GetLocationExpiry + "?location=" + location.Name, undefined, true, new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser()))
                .then(function (response) {
                return __assign(__assign({}, location), { Expiry: response });
            }).catch(function (reason) {
                return console.error("Error loading locations, with reason: " + reason);
            });
        };
        _this.getLocationExpiryAsync = function (item) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getLocationExpiry(item)];
            });
        }); };
        _this.getData = function (locationData) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all(locationData.map(function (item) { return _this.getLocationExpiryAsync(item); }))];
            });
        }); };
        _this.toggle = function (location) {
            //console.log(location);
            //console.log(location != undefined);
            if (location != undefined) {
                _this.setState({
                    currentLocation: location
                });
            }
            _this.setState(function (prevState) {
                return {
                    modal: !prevState.modal
                };
            }, function () {
                var closeButton = document.getElementsByClassName("close")[0];
                if (closeButton != null || closeButton != undefined) {
                    closeButton.style.display = "none";
                }
            });
        };
        _this.changePage = function (newPage) {
            _this.setState({
                page: newPage
            });
        };
        _this.updateCallback = function (updateSelectedLocation) {
            if (updateSelectedLocation === void 0) { updateSelectedLocation = ""; }
            //console.log("Update Callback Locations.tsx");
            Util_1.getJson(Endpoints_1.default.GetLocations, undefined, true, new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser()))
                .then(function (response) {
                var value = JSON.parse(response);
                _this.props.applicationData.updateCallback("locations", value);
                var totalPages = Math.ceil(value.length / 10);
                var page = _this.state.page <= totalPages ? _this.state.page : totalPages;
                _this.setState({
                    page: page,
                    totalPages: totalPages,
                    parseLocationData: true
                });
            }).catch(function (reason) {
                return console.error("Error loading locations, with reason: " + reason);
            });
            if (updateSelectedLocation != "") {
                _this.props.applicationData.updateCallback(AuthenticationService_1.AuthenticationService.selectedLocationKey, updateSelectedLocation);
            }
        };
        _this.certRenewalUpdateCallback = function (locationName, expiry) {
            _this.setState(function (prevState) {
                return {
                    locationData: _this.addActionsToLocationData(prevState.locationData.map(function (location) {
                        if (location.Name === locationName) {
                            return __assign(__assign({}, location), { Expiry: expiry });
                        }
                        return location;
                    }))
                };
            });
        };
        _this.state = {
            modal: false,
            currentLocation: undefined,
            page: 1,
            totalPages: Math.ceil(props.applicationData.locations.length / 10),
            locationData: _this.addActionsToLocationData(props.applicationData.locations).map(function (location) { location.Expiry = React.createElement(reactstrap_1.Spinner, { size: "sm", color: "secondary" }); return location; }),
            parseLocationData: false
        };
        _this.clientIdRef = React.createRef();
        _this.clientSecretRef = React.createRef();
        _this.deleteLocationRef = React.createRef();
        _this.locationNameRef = React.createRef();
        _this.locationNameFeedbackRef = React.createRef();
        _this.clientIdFeedbackRef = React.createRef();
        _this.clientSecretFeedbackRef = React.createRef();
        return _this;
    }
    Locations.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.applicationData.apiProvider != "Ssr") {
            this.getData(this.state.locationData).then(function (locations) {
                _this.setState({ locationData: _this.addActionsToLocationData(locations) });
            });
        }
    };
    Locations.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.parseLocationData) {
            if (this.props.applicationData.apiProvider != "Ssr") {
                this.getData(this.props.applicationData.locations).then(function (locations) {
                    _this.setState({
                        locationData: _this.addActionsToLocationData(locations),
                        parseLocationData: false
                    });
                });
            }
            else {
                this.setState({
                    locationData: this.addActionsToLocationData(this.props.applicationData.locations),
                    parseLocationData: false
                });
            }
        }
    };
    Locations.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "my-1" },
            React.createElement("div", { className: "my-2 fv-c" },
                React.createElement("h2", null, this.props.applicationData.resources.Locations),
                React.createElement(reactstrap_1.Button, { className: "locations-add-btn ml-3", color: "primary", onClick: function () {
                        EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.AddLocationEvent(_this.updateCallback, _this.props.applicationData));
                    } },
                    " ",
                    this.props.applicationData.resources.AddNewLocation,
                    " ")),
            React.createElement(react_bootstrap_table_next_1.default, { bootstrap4: true, condensed: true, hover: true, bordered: false, keyField: "Name", data: this.state.locationData, columns: getColumns(this.props.applicationData.apiProvider, this.props.applicationData.resources), defaultSorted: defaultSorted, pagination: react_bootstrap_table2_paginator_1.default() })));
    };
    return Locations;
}(React.Component));
exports.Locations = Locations;
//# sourceMappingURL=Locations.js.map